// const HTTP = 'http'

let IP
// const IP = '172.16.35.112' // 生产环境【内网】
// const IP = '39.105.30.231' // 生产环境【外网】
// const IP = '10.10.0.232' // 测试环境【内网】
// const IP = '127.0.0.1' // 本地环境
if (process.env.NODE_ENV === 'development') {
  IP = 'http://192.168.2.45:9138'
} else if (process.env.NODE_ENV === 'test') {
  IP = '10.10.0.232'
} else if (process.env.NODE_ENV === 'production') {
  // IP = '39.105.30.231'
  IP = ''
} else {
  IP = '39.105.30.231'
  throw new Error('process.env.NODE_ENV is not defined')
}

// const baseURL = `${HTTP}://${IP}`
// const baseURL = ``
export default IP



// WEBPACK FOOTER //
// ./src/api/base.js